import { createSelector } from 'reselect'

const uiSelector = state => state.ui

export default createSelector(
	[uiSelector],
	uiSelectorData => ({
		fromLTI: uiSelectorData.fromLTI,
		referer: uiSelectorData.referer,
		lcsbt: uiSelectorData.lcsbt,
	})
)
